import React from 'react'
import { Checkbox, FormControlLabel } from '@material-ui/core'

const QuestionnaireCheckbox = ({
  quizTemplate,
  checked,
  onChange,
  isMandatory = false,
  disabled = false,
}) => {
  const label = isMandatory
    ? `${quizTemplate.kind} (obrigatório)`
    : quizTemplate.kind

  return (
    <FormControlLabel
      key={quizTemplate.id}
      control={
        <Checkbox
          name={`${quizTemplate.id}`}
          checked={checked}
          onChange={onChange}
          disabled={isMandatory || disabled}
        />
      }
      label={label}
    />
  )
}

export default QuestionnaireCheckbox
